"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const Transform = (props) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "icon icon-tabler icons-tabler-outline icon-tabler-transform", ...props },
    React.createElement("path", { d: "M0 0h24v24H0z", stroke: "none" }),
    React.createElement("path", { d: "M3 6a3 3 0 106 0 3 3 0 00-6 0M21 11V8a2 2 0 00-2-2h-6l3 3m0-6l-3 3M3 13v3a2 2 0 002 2h6l-3-3m0 6l3-3M15 18a3 3 0 106 0 3 3 0 00-6 0" }));
exports.default = Transform;
